import { useEffect, useState } from "react";

export const useLocationService = () => {
  const [location, setLocation] = useState({});

  useEffect(() => {
    const getUserLocation = () => {
      return new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
          reject(new Error("Geolocation not supported by your browser."));
          return;
        }

        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude: lat, longitude: lng } = position.coords;
            resolve({ lat, lng });
          },
          (error) => {
            let errorMessage;
            switch (error.code) {
              case error.PERMISSION_DENIED:
                errorMessage = "Location access denied. Please enable location permissions or try using a different browser.";
                break;
              case error.POSITION_UNAVAILABLE:
                errorMessage = "Location information is unavailable.";
                break;
              case error.TIMEOUT:
                errorMessage = "Location request timed out. Please try again.";
                break;
              default:
                errorMessage = "An unknown error occurred.";
            }
            const detailedError = new Error(errorMessage);
            detailedError.code = error.code;
            // Set default location if permission denied
            if (error.code === error.PERMISSION_DENIED) {
              setLocation({ lat: 3.1339619, lng: 101.6825585 });
            }
            reject(detailedError);
          }
        );
      });
    };

    getUserLocation()
      .then(setLocation)
      .catch((error) => {
        setLocation({ lat: 3.1339619, lng: 101.6825585 });
        console.error("Location error:", error.message);
      });
  }, []);

  return location;
};
